angular.module('contactModule').component('contactRental', {
	templateUrl: 'contactRental/contactRental.html',
	bindings: {
		page: '<',
		target: '<',
		user: '<',
		type: '<',
		steps: '<',
		trackCategory: '<',
		trackAction: '<',
		trackActionPhone: '<',
		trackActionPhoneCall: '<',
		trackLabel: '<',
		tabindexOrder: '<',
		errorMessages: '<',
		successMessage: '<',
		pageLabel: '<',
		objectId: '<',
		isMobile: '<',
		onSubmitForm: '&'
	},
	controller: ['$timeout', '$window', 'PubSub', '$element', 'crResourcesService', function($timeout, $window, PubSub, $element, crResourcesService) {
		var ctrl = this;
		this.showDisclaimer = false;

		this.$onInit = () => {
			if (this.type === 'listing-rent') {
				this.viewWebsiteLink = `View on ${this.target.name}`;
			} else if (this.type === 'building-rental') {
				this.viewWebsiteLink = `Building Website`;
			}

			// hide listing agent phone number
			if (this.type === 'listing-rent' && this.target.phone) {
				this.target.showFullPhone = false;
				this.target.showPartialPhone = true;
				this.target.partialPhone = this.target.phone.slice(0, this.target.phone.length - 4).concat('XXXX');
			}
		};

		this.$postLink = () => {
			$timeout(() => {
				let $regLinks = $element[0].querySelectorAll('.reg_blimp');
				for (let i = 0; i < $regLinks.length; i++) {
					// Fire GLOBAL event (jquery and mootools)
					var event = document.createEvent("HTMLEvents");
					event.initEvent("addRegLink", true, true);
					event.eventEl = $regLinks[i];
					document.dispatchEvent(event);
				}
			});
		};

		this.setStep = (step) => {
			if (!this.isMobile && step === this.steps.STEP2) {
				crTrackerQueue.track({
					category: this.trackCategory,
					action: this.trackAction,
					label: this.trackLabel
				});
			}

			this.steps.current = step;
		};

		this.displayPartialPhone = (agent) => {
			return this.target.phone.slice(0, this.target.phone.length - 4) + '<span class="phone-hidden">XXXX</span>';
		};

		this.showFullPhone = () => {
			this.target.showFullPhone = true;

			crTrackerQueue.track({
				category: this.trackCategory,
				action: this.trackActionPhone,
				label: this.trackLabel
			});
		};

		this.trackCall = () => {
			crTrackerQueue.track({
				category: this.trackCategory,
				action: this.trackActionPhoneCall,
				label: this.trackLabel
			});
		};

		this.submit = function() {
			this.onSubmitForm({form: this.form});
		};
	}]
});